/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-unused-expressions */
import { KeyboardEvent, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import * as MUI from "@mui/material";
import * as MUIcons from "@mui/icons-material";

import { useAuth } from "../../../hooks/auth";
import { carcerarioStoreRG } from "../../../hooks/store";

import { LayoutConsultaCarcerario } from "./LayoutConsultaCarcerario";
import { ResultadoConsultaCarcerario } from "../../../components";

type InputProps = {
  rg: string;
};

export const FiltroCarcerarioRG: React.FC = () => {
  const { control, handleSubmit } = useForm<InputProps>({
    defaultValues: {
      rg: "",
    },
  });

  const { user } = useAuth();
  const { url } = user!.sistemas.filter((s) => {
    return s.id_sistema === 4 ? s.url : false;
  })[0];

  const {
    consultaCarcerarioRG,
    resultadoCarcerarioRG,
    mensagemCarcerario,
    limparConsultaCarcerarioRG,
  } = carcerarioStoreRG((state) => state.carcerario);
  const { loading } = carcerarioStoreRG((state) => state.global);

  const pesquisaCarcerarioRG = (data: InputProps) => {
    consultaCarcerarioRG(url, data.rg);
  };

  const keyBoardClick = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    e.key === "Enter";
  }, []);

  return (
    <LayoutConsultaCarcerario>
      <MUI.Grid
        component="form"
        alignItems="center"
        width={["100%", "100%", "100%", "80%", "60%"]}
        container
        spacing={1}
        onSubmit={handleSubmit(pesquisaCarcerarioRG)}
      >
        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="rg"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MUI.TextField
                label="Informe o RG"
                value={value.replace(/\D/g, "")}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={3} sm={3}>
          <MUI.Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={loading}
            startIcon={<MUIcons.Search />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Consultar
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>

        <MUI.Grid item xs={12} md={3} sm={3}>
          <MUI.Button
            fullWidth
            variant="outlined"
            color="secondary"
            onClick={limparConsultaCarcerarioRG}
            disabled={loading}
            startIcon={<MUIcons.Clear />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Limpar resultado
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>
      </MUI.Grid>

      <MUI.Stack>
        {resultadoCarcerarioRG || mensagemCarcerario ? (
          <MUI.Typography variant="h6">Resultado da consulta:</MUI.Typography>
        ) : (
          false
        )}

        {!loading ? (
          (resultadoCarcerarioRG &&
            resultadoCarcerarioRG?.map((cidadao) => (
              <ResultadoConsultaCarcerario
                key={cidadao.DET_ID}
                situacao={cidadao.SITUACAO}
                infoNome={cidadao.DET_NOME}
                vulgo={cidadao.DET_NOMEVULGO}
                infoMae={cidadao.DET_NOMEMAE}
                infoPai={cidadao.DET_NOMEPAI}
                to={`consulta-carcerario/ficha-carcerario/${cidadao.DET_ID}`}
              />
            ))) || (
            <MUI.Typography variant="h6">{mensagemCarcerario}</MUI.Typography>
          )
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </LayoutConsultaCarcerario>
  );
};
